import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { catchError, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class I18nService implements TranslateLoader {
  private readonly http = inject(HttpClient);

  getTranslation(language: string): Observable<TranslationObject> {
    return this.http
      .get<TranslationObject>(`/assets/i18n/${language.toLowerCase()}/widget.json`)
      .pipe(catchError(() => of({})));
  }
}
